

















































































































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import CardModalDetailPasien from "@/components/modal/CardModalDetailPasien.vue";
import { storePasien } from "@/store/modules/pasien";
import moment from "moment";
import HeartFailureIndicator from "@/components/icons/HeartFailureIndicator.vue";
import PasienCustomWarningIndicator from "@/components/icons/PasienCustomWarningIndicator.vue";
// import registerHf from "@/services/registerHf";
import { userModule } from "@/store/modules/user";
import storePanggilanLayanan from "@/store/modules/new/PanggilanLayanan";
import { toggleHeartFailureIndicator } from "@/utility/PasienTagHelper";
import PasienContextMenuButton from "@/components/icons/PasienContextMenuButton.vue";
// import SkriningStore from "@/store/modules/new/SkriningStore";
import PasienMultiWarningIndicator from "@/components/icons/PasienMultiWarningIndicator.vue";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import StatusPrioritas, { PrioritasFlag } from "@/services/StatusPrioritas";
import { FormIndexEntry } from "@/utils/ranapFormRegistry";

@Component({
  components: {
    CardModalDetailPasien,
    HeartFailureIndicator,
    PasienCustomWarningIndicator,
    PasienContextMenuButton,
    PasienMultiWarningIndicator
  }
})
export default class PasienFlyingBar extends Vue {
  // pasien = {};
  fab = false;
  openRightNavigationDrawer = true;
  modalOpen = false;
  bpjsDialogOpen = false;
  prioritasFlags: PrioritasFlag[] = [];

  // Universal cross-tab form search (only rendered when the parent passes an index,
  // i.e. the Ranap exam page). Selecting an entry emits "open-form" to the parent.
  @Prop({ default: () => [] }) formIndex!: FormIndexEntry[];
  @Prop({ type: Boolean, default: false }) readonly ranap!: boolean;
  formSearchModel: FormIndexEntry | null = null;

  filterFormIndex(item: FormIndexEntry, queryText: string): boolean {
    const q = (queryText || "").toLowerCase().trim();
    if (!q) {
      return true;
    }
    const hay = `${item.label} ${item.group} ${item.keywords || ""}`.toLowerCase();
    return q.split(/\s+/).every((term) => hay.includes(term));
  }

  onPickForm(item: FormIndexEntry | null) {
    if (item) {
      this.$emit("open-form", item);
    }
    // Clear the field so the same form can be picked again next time.
    this.$nextTick(() => {
      this.formSearchModel = null;
    });
  }

  skeleteonAttrs: {
    class: "";
    boilerplate: true;
    elevation: 2;
  };

  detailPasien() {
    this.modalOpen = true;
  }

  showBpjsDialog() {
    this.bpjsDialogOpen = true;
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get isBatuk() {
    return storePasien.hasSkriningBatuk;
  }

  get hasRegHFTag() {
    return storePasien.isTagRegHF;
  }

  get pasienTag() {
    return storePasien.pasienTag;
  }

  get pasienTagText() {
    return this.pasienTag.map(it => {
      return it.activeText;
    });
  }

  get loadingPasienTag() {
    return storePasien.loadingPasienTag;
  }

  get jKelamin() {
    return this.statePasien?.jk;
  }

  getHumanDate(date) {
    return date ? moment(date, "DD-MM-YYYY").format("DD MMMM YYYY") : "";
  }
  showDrawer() {
    this.rightDrawer = !this.rightDrawer;
    this.fab = !this.fab;
    this.$emit("rightdrawer", this.rightDrawer);
  }
  get rightDrawer() {
    return this.openRightNavigationDrawer;
  }

  set rightDrawer(_openRightNavigationDrawer: boolean) {
    this.openRightNavigationDrawer = _openRightNavigationDrawer;
  }

  get showRegisterHF() {
    return (
      this.ranap || ["01", "27"].includes(userModule.user.unit_group_id)
    );
  }

  get showHFIndicator() {
    return this.statePasien?.rm !== "";
  }

  get panggilanDokter() {
    return storePanggilanLayanan.allPanggilan.find(
      item => item.unit_id == "02" && item.dr_id == "XXX"
    ).dokter_call;
  }

  get registerKunjungan() {
    return RegisterKunjungan.register;
  }

  get infoBpjs() {
    return RegisterKunjungan.infoBpjs;
  }

  get rujukanDaysRemaining() {
    return RegisterKunjungan.rujukanDaysRemaining;
  }

  get rujukanWarning() {
    return this.rujukanDaysRemaining !== null && this.rujukanDaysRemaining < 30
      ? Math.max(0, this.rujukanDaysRemaining)
      : null;
  }

  get rujukanWarningText() {
    if (this.rujukanWarning !== null) {
      return this.rujukanWarning > 0
        ? `${this.rujukanWarning} hr lg!`
        : "Rujukan habis!";
    }

    return null;
  }

  get rujukanWarningTextTitle() {
    if (this.rujukanWarningText) {
      return this.rujukanWarning > 0
        ? `Rujukan habis dalam ${this.rujukanWarning} hari!`
        : `Rujukan sudah habis! (${RegisterKunjungan.rujukanExpiredDate})`;
    }

    return null;
  }

  @Watch("registerKunjungan")
  changeRegisterKunjungan(val) {
    if (val && val.is_bpjs) {
      RegisterKunjungan.getInfoBpjs(val.no);
    }
  }

  get prioritasLabels() {
    return this.prioritasFlags.map(it => it.label);
  }

  get currentRegister() {
    return this.$route.params.register;
  }

  @Watch("currentRegister", { immediate: true })
  async changeCurrentRegister(reg) {
    this.prioritasFlags = reg ? await StatusPrioritas.getByRegister(reg) : [];
  }

  toggleRegHF() {
    toggleHeartFailureIndicator(
      () => {
        storePasien.getPasienTag();
      },
      () => {
        storePasien.getPasienTag();
      }
    );
  }

  getHashedClue(str, length = 3) {
    const words = str.trim().split(/\s+/);
    const result = [];

    for (const word of words) {
      result.push(word);
      if (word.length > length) break;
    }

    return result.join(" ") + "################";
  }
}
